<template>
  <div id="loading" style="text-align: center">
    <div class="loadin-icon"></div>
  </div>
</template>

<script>
  export default {
    name: 'LoadingOverlay'
  }
</script>

<style scoped>
  #loading {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(253, 253, 253, 0.7);
    z-index: 999;
    cursor: pointer;
    background-image: url('~@/assets/images/loading.gif');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 220px 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Loading/Loading.vue